import { Typography} from '@mui/material';


export default function LabfinderSubText() {

    return (

            <Typography variant="h6" fontWeight={400}>

                Pick a certified lab near you. You can go there without appointment, but you will need an ID and a valid speak23 subscription
                for checking in there. After the blood draw it takes usually not more than 2-3 days until you results will be in the speak23
                dashboard.

            </Typography>
            
)
}